var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pill",class:{'isActive': _vm.isActive}},[_c('div',{staticClass:"pill-indicator"}),_vm._v(" "),_c('div',{staticClass:"pill-on-text"},[_vm._v(_vm._s(_vm.isActiveLabel))]),_vm._v(" "),_c('div',{staticClass:"pill-off-text"},[_vm._v(_vm._s(_vm.isNotActiveLabel))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed71052","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Pill.vue
// module id = 3Q69
// module chunks = 1